import { render, staticRenderFns } from "./HbTextarea.vue?vue&type=template&id=b12cb316&"
import script from "./HbTextarea.vue?vue&type=script&lang=js&"
export * from "./HbTextarea.vue?vue&type=script&lang=js&"
import style0 from "./HbTextarea.vue?vue&type=style&index=0&id=b12cb316&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports